import React from 'react';
import path from 'constants/paths';
import AwsIcon from 'components/atoms/icons/awsIcon';
import PropTypes from 'prop-types';

const MenuItemAmazonConnect = ({ onClick }) => (
  <div className="menu-item-icon">
    <a
      href={path.awsConnectURL}
      target="_blank"
      className="menu-item-icon__link"
      onClick={onClick}
    >
      <div className="menu-item-icon__icon">
        <AwsIcon />
      </div>
      <div className="menu-item-icon__text">Amazon connect</div>
    </a>
  </div>
);

MenuItemAmazonConnect.defaultProps = {
  onClick: () => {},
};

MenuItemAmazonConnect.propTypes = {
  onClick: PropTypes.func,
};

export default MenuItemAmazonConnect;
